/**
 * Normalize a hash fragment key to a leading-`#` form, or empty string when absent.
 */
export function normalizeHash(hashKey?: string | null) {
  if (!hashKey) return ""

  return hashKey.startsWith("#") ? hashKey : `#${hashKey}`
}

export type WithUrlHashOptions = {
  /** Base origin used when resolving relative URLs. Defaults to `window.location.origin` or `http://localhost`. */
  baseOrigin?: string
}

/**
 * Return `url` with `hashKey` applied as the URL hash. Relative paths and absolute
 * http(s) URLs are both supported.
 */
export function withUrlHash(
  url: string,
  hashKey?: string | null,
  options?: WithUrlHashOptions
) {
  const hash = normalizeHash(hashKey)
  if (!hash) return url

  const baseOrigin =
    options?.baseOrigin ??
    (typeof window !== "undefined"
      ? window.location.origin
      : "http://localhost")

  try {
    const resolvedUrl = new URL(url, baseOrigin)
    resolvedUrl.hash = hash

    return /^https?:\/\//.test(url)
      ? resolvedUrl.toString()
      : `${resolvedUrl.pathname}${resolvedUrl.search}${resolvedUrl.hash}`
  } catch {
    return `${url.replace(/#.*$/, "")}${hash}`
  }
}
